<footer class="border-t border-slate-200 bg-white px-6 py-3 text-xs text-slate-500 dark:border-slate-800 dark:bg-slate-900 dark:text-slate-400">
  {{ i18n.translate('app.version') }} v{{ appVersion }}
</footer>
